import dynamic from 'next/dynamic';
import { Text, Image, Button } from '@belong/ui';
import { type BelongStandardsProps } from 'src/features/belong-standards/components/belong-standards/belong-standards';
import { STRINGS } from 'src/features/belong-standards/strings';
import { useFeatureFlag } from 'src/features/feature-flags/hooks';
import { useModal } from 'src/hooks/useModal';
import css from './belong-standards-landing-link.module.css';

const BelongStandards = dynamic<BelongStandardsProps>(() =>
  import('src/features/belong-standards/components/belong-standards/belong-standards').then(
    (mod) => mod.BelongStandards,
  ),
);

export function BelongStandardsLandingLink() {
  const [
    isBelongStandardsModalOpen,
    openBelongStandardsModal,
    closeBelongStandardsModal,
  ] = useModal();
  const { isEnabled: isBelongStandardsEnabled } =
    useFeatureFlag('belong-standards');

  return (
    <>
      {isBelongStandardsEnabled && (
        <div className="mb-2xl lg:gap-xs flex flex-col items-center justify-center text-center lg:flex-row">
          <div className="mb-xs h-xl w-[50px] lg:mb-0">
            <Image
              src="modals/belong-standards/belong_standard_badge_sm.png"
              className="object-cover"
              alt="Belong Standard Badge"
            />
          </div>
          <div className="mb-lg max-w-xs lg:mb-0 lg:max-w-none">
            <Text className={css.belongStandards} fontWeight="semibold">
              {STRINGS.belongStandards}
            </Text>
          </div>
          <Button variant="text" onClick={openBelongStandardsModal}>
            <Text fontWeight="semibold">{STRINGS.learnMore}</Text>
          </Button>
        </div>
      )}
      {isBelongStandardsModalOpen && (
        <BelongStandards isOpen onDismiss={closeBelongStandardsModal} />
      )}
    </>
  );
}
